import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

export async function getTgBotUserBongo(docId) {
  try {
    const docRef = doc(db, 'tg-bot-users-bongo', docId);
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) return null;
    return { id: snapshot.id, ...snapshot.data() };
  } catch (err) {
    console.error('[Firestore] getTgBotUserBongo error:', err?.code, err?.message);
    throw err;
  }
}
